import Flex from "../flex/Flex";
import { Icon, IconName } from "../icons/Icon";
import { twMerge } from "tailwind-merge";
import { colors } from "~/utils/tailwindUtils";

type ErrorBannerProps = {
  withIcon?: boolean;
  children?: React.ReactNode;
  containerClassName?: string;
  errorLevel?: "error" | "warning";
};
/**
 * ErrorBanner component to display error messages
 * @param withIcon - Whether to display an icon
 * @param children - The content to display
 * @param containerClassName - The class name for the container
 * @param errorLevel - The level of the error (error or warning)
 * @returns The ErrorBanner component
 */
const ErrorBanner = ({ withIcon, children, containerClassName, errorLevel = "error" }: ErrorBannerProps) => {
  return (
    <Flex
      className={twMerge(
        "flex-row items-center gap-2 bg-red-50 rounded-lg p-4 border border-red-600 w-full justify-center",
        errorLevel === "warning" && "bg-yellow-100 border-none",
        containerClassName
      )}
    >
      {withIcon && (
        <Icon
          name={IconName.AlertTriangle}
          className={"mr-2"}
          color={errorLevel === "error" ? colors.red[800] : colors.orange[500]}
        />
      )}
      <Flex className={twMerge("text-sm font-medium", errorLevel === "error" ? "text-red-800" : "text-yellow-800")}>
        {children}
      </Flex>
    </Flex>
  );
};

export default ErrorBanner;
